/**
 * ============================================
 * FordSync4 Content Gate
 *
 * 在文章编辑器里切换到 HTML 模式 (点 <> 按钮)，
 * 在你想锁定的位置插入: <!-- customer-only -->
 * 这行之上的内容所有人可见（含Google），
 * 这行之下的内容需要订单验证后才能看到。
 *
 * 上传到 Shopify Assets 即可，snippet 会自动加载
 * ============================================
 */

(function() {
  'use strict';

  var API_BASE = 'https://fordsync4-comments.fordsync4.workers.dev';

  function getToken() { return localStorage.getItem('fs4_token'); }
  function setToken(t) { localStorage.setItem('fs4_token', t); }

  async function api(path, options) {
    options = options || {};
    var token = getToken();
    var headers = { 'Content-Type': 'application/json' };
    if (token) headers['Authorization'] = 'Bearer ' + token;
    var res = await fetch(API_BASE + path, Object.assign({}, options, { headers: headers }));
    return res.json();
  }

  // 找到文章内容容器
  var selectors = [
    '.article-template__content .rte',
    '.article-template__content',
    '.article__content .rte',
    '.article__content',
    '[itemprop="articleBody"]',
    '.rte'
  ];

  var articleEl = null;
  for (var i = 0; i < selectors.length; i++) {
    articleEl = document.querySelector(selectors[i]);
    if (articleEl) break;
  }
  if (!articleEl) return;

  // 在 innerHTML 中寻找标记 (HTML注释在DOM中是comment节点)
  var markerNode = null;

  function findMarker(parent) {
    var children = parent.childNodes;
    for (var i = 0; i < children.length; i++) {
      var node = children[i];
      if (node.nodeType === 8 && node.textContent.trim().toLowerCase() === 'customer-only') {
        markerNode = node;
        return true;
      }
      if (node.nodeType === 1) {
        if (findMarker(node)) return true;
      }
    }
    return false;
  }

  findMarker(articleEl);
  if (!markerNode) return; // 没有标记，不做任何事，文章正常显示

  // 把标记后面的所有内容收集起来
  var hiddenElements = [];

  // 从标记节点开始，收集之后的所有兄弟
  var walkNode = markerNode;
  var walkParent = markerNode.parentNode;

  // 收集同级的后续节点
  var next = walkNode.nextSibling;
  while (next) {
    hiddenElements.push(next);
    next = next.nextSibling;
  }

  // 如果标记不在文章根级别，还需要收集父元素之后的兄弟
  if (walkParent !== articleEl) {
    next = walkParent.nextSibling;
    while (next) {
      hiddenElements.push(next);
      next = next.nextSibling;
    }
  }

  if (hiddenElements.length === 0) return;

  // 创建隐藏容器
  var gated = document.createElement('div');
  gated.id = 'fs4-gated-content';
  gated.style.display = 'none';
  for (var j = 0; j < hiddenElements.length; j++) {
    gated.appendChild(hiddenElements[j]);
  }

  // 移除注释节点本身
  if (markerNode.parentNode) markerNode.parentNode.removeChild(markerNode);

  // 创建锁定提示框
  var lockBox = document.createElement('div');
  lockBox.id = 'fs4-content-lock';

  var style = document.createElement('style');
  style.textContent =
    '#fs4-content-lock{margin:32px 0;text-align:center}' +
    '.fs4-gate{background:linear-gradient(180deg,#f8fbff 0%,#eef4fb 100%);border:2px solid #003478;border-radius:12px;padding:40px 32px;max-width:560px;margin:0 auto}' +
    '.fs4-gate-icon{font-size:48px;margin-bottom:12px}' +
    '.fs4-gate h3{font-size:20px;font-weight:700;color:#003478;margin:0 0 8px}' +
    '.fs4-gate p{font-size:15px;color:#4a5568;margin:0 0 20px;line-height:1.6}' +
    '.fs4-gate-tags{display:flex;flex-wrap:wrap;gap:8px;justify-content:center;margin-bottom:24px}' +
    '.fs4-gate-tag{background:#e6f0ff;color:#003478;padding:4px 12px;border-radius:16px;font-size:13px;font-weight:600}' +
    '.fs4-gate-form{display:grid;grid-template-columns:1fr 1fr;gap:12px;max-width:400px;margin:0 auto}' +
    '.fs4-gate-form input{width:100%;padding:10px 12px;border:1px solid #d0d7e2;border-radius:6px;font-size:14px;box-sizing:border-box}' +
    '.fs4-gate-form input:focus{border-color:#003478;outline:none;box-shadow:0 0 0 3px rgba(0,52,120,0.1)}' +
    '.fs4-gate-submit{grid-column:1/-1;background:#003478;color:#fff;border:none;border-radius:6px;padding:12px;font-size:15px;font-weight:600;cursor:pointer;transition:background 0.15s}' +
    '.fs4-gate-submit:hover{background:#1a5dab}' +
    '.fs4-gate-submit:disabled{opacity:0.5;cursor:not-allowed}' +
    '.fs4-gate-err{grid-column:1/-1;background:#fff5f5;color:#c53030;padding:8px 12px;border-radius:6px;font-size:14px;border:1px solid #fed7d7;text-align:left}' +
    '.fs4-gate-hint{font-size:12px;color:#a0aec0;margin-top:4px;text-align:left}' +
    '@media(max-width:600px){.fs4-gate-form{grid-template-columns:1fr}.fs4-gate{padding:28px 20px}}';

  lockBox.appendChild(style);

  var box = document.createElement('div');
  box.className = 'fs4-gate';
  box.innerHTML =
    '<div class="fs4-gate-icon">\uD83D\uDD12</div>' +
    '<h3>Customer-exclusive content</h3>' +
    '<p>The full guide below is available to verified FordSync4 customers.<br>Sign in with your order number to unlock.</p>' +
    '<div class="fs4-gate-tags">' +
      '<span class="fs4-gate-tag">Detailed instructions</span>' +
      '<span class="fs4-gate-tag">Wiring diagrams</span>' +
      '<span class="fs4-gate-tag">Hidden features</span>' +
      '<span class="fs4-gate-tag">Technical specs</span>' +
    '</div>' +
    '<div id="fs4-gate-error"></div>' +
    '<div class="fs4-gate-form">' +
      '<div><input type="text" id="fs4-gate-order" placeholder="Order # (e.g., FS4****)" /><div class="fs4-gate-hint">From your confirmation email</div></div>' +
      '<div><input type="text" id="fs4-gate-name" placeholder="Name on order" /><div class="fs4-gate-hint">First, last, or full name</div></div>' +
      '<button class="fs4-gate-submit" id="fs4-gate-btn">\uD83D\uDD13 Unlock Full Guide</button>' +
    '</div>';
  lockBox.appendChild(box);

  // 插入到文章中
  articleEl.appendChild(lockBox);
  articleEl.appendChild(gated);

  // 解锁函数
  function unlock() {
    lockBox.style.display = 'none';
    gated.style.display = 'block';
    // 同时解锁评论区的登录状态 (如果评论 widget 也在页面上)
  }

  // 检查已有登录状态
  async function checkAuth() {
    var token = getToken();
    if (!token) return;
    try {
      var data = await api('/api/auth/me');
      if (data.user) unlock();
    } catch(e) { /* 忽略 */ }
  }

  // 登录验证
  async function handleUnlock() {
    var orderEl = document.getElementById('fs4-gate-order');
    var nameEl = document.getElementById('fs4-gate-name');
    var errEl = document.getElementById('fs4-gate-error');
    var btn = document.getElementById('fs4-gate-btn');

    var order = orderEl ? orderEl.value.trim() : '';
    var name = nameEl ? nameEl.value.trim() : '';

    if (!order || !name) {
      errEl.innerHTML = '<div class="fs4-gate-err">Please enter both order number and name.</div>';
      return;
    }

    btn.textContent = 'Verifying...';
    btn.disabled = true;
    errEl.innerHTML = '';

    try {
      var result = await api('/api/auth/login', {
        method: 'POST',
        body: JSON.stringify({ orderNumber: order, name: name }),
      });

      if (result.success) {
        setToken(result.token);
        unlock();
      } else {
        errEl.innerHTML = '<div class="fs4-gate-err">' + esc(result.error || 'Verification failed.') + '</div>';
        btn.textContent = '\uD83D\uDD13 Unlock Full Guide';
        btn.disabled = false;
      }
    } catch(e) {
      errEl.innerHTML = '<div class="fs4-gate-err">Network error. Please try again.</div>';
      btn.textContent = '\uD83D\uDD13 Unlock Full Guide';
      btn.disabled = false;
    }
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s || '';
    return d.innerHTML;
  }

  // 绑定事件
  setTimeout(function() {
    var btn = document.getElementById('fs4-gate-btn');
    if (btn) btn.addEventListener('click', handleUnlock);
    var ids = ['fs4-gate-order', 'fs4-gate-name'];
    ids.forEach(function(id) {
      var el = document.getElementById(id);
      if (el) el.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') handleUnlock();
      });
    });
  }, 0);

  checkAuth();

})();
